import React, { useEffect, useState } from "react";
import RapidTrustRadar from "./RapidTrustRadar";
import StressCircle from "./StressCircle";
import { useNavigate } from "react-router-dom";
import useOrganization from "../../organization/hooks/useOrganization";
import { getSurveyScores } from "../api/individualResults.api";

const trustKeyMap = [
  { key: "Independence", label: "Independence" },
  { key: "Advancement", label: "Advancement" },
  { key: "Exploring", label: "Exploring" },
  { key: "Caring", label: "Caring" },
  { key: "Collaboration", label: "Collaboration" },
  { key: "Safety", label: "Safety" },
];

const stressKeyMap = [
   { key: "Arguing", label: "Arguing", color: "#f4a261" },
  { key: "Freezing", label: "Freezing", color: "#6c757d" },
  { key: "Retreating", label: "Retreating", color: "#6c757d" },
  { key: "Audacious", label: "Audacious", color: "#ef4444" },
  { key: "Appeasing", label: "Appeasing", color: "#6c757d" },
];

const IndividualResultsPreview: React.FC = () => {
  const { currentOrganization } = useOrganization();
  const navigate = useNavigate();

  const [trustData, setTrustData] = useState<any[]>([]);
  const [stressData, setStressData] = useState<any[]>([]);

  const questionnaireId = currentOrganization?.default_survey;

  useEffect(() => {
    if (!questionnaireId || questionnaireId <= 0) return;

    const loadScores = async () => {
      try {
        const res = await getSurveyScores(Number(questionnaireId));
        const scores = res.data.scores;

        const trustMapped = trustKeyMap.map((item) => ({
          label: item.label,
          value: Math.round(scores[item.key] || 0),
        }));

        const stressMapped = stressKeyMap.map((item) => ({
          label: item.label,
          value: Math.round(scores[item.key] || 0),
          color: item.color,
        }));

        setTrustData(trustMapped);
        setStressData(stressMapped);
      } catch (err) {
        console.error(err);
      }
    };

    loadScores();
  }, [questionnaireId]);

  const sortedTrust = [...trustData].sort((a, b) => b.value - a.value);
  const primary = sortedTrust[0];
  const secondary = sortedTrust[1];

  return (
    <div className="bg-white rounded-xl shadow-sm p-5 h-full flex flex-col">

      {/* Header */}
      <div className="flex items-center justify-between mb-4">

        <h4 className="text-[#26295e] font-semibold">
          Individual Results
        </h4>

        <button
          className="
      bg-[#3b519c]
      hover:bg-[#2f407c]
      text-white
      px-4 py-2
      rounded-lg
      text-sm
      shadow-sm
      transition
    "
          onClick={() => navigate("/individual-results")}
        >
          View Results
        </button>

      </div>

      {/* Rapid Trust */}
      <h6 className="mb-3 text-[#26295e] text-sm">
        Rapid Trust Build
      </h6>

      <div className="bg-white rounded-xl p-4 mb-8">

        {/* Radar */}
        <div className="flex justify-center items-center mb-6 min-h-[160px]">
          <RapidTrustRadar
            data={trustData.map((d) => d.value)}
            interactive={false}
          />
        </div>

        {/* Progress */}
        <div className="flex flex-col space-y-4">

          {primary && (
            <div>
              <div className="flex justify-between text-sm text-[#26295e] mb-1">
                <span>{primary.label}</span>
                <span>{primary.value}%</span>
              </div>

              <div className="h-1 bg-[#e6eaf6] rounded-full relative">
                <div
                  className="h-1 bg-[#2f2a68] rounded-full"
                  style={{ width: `${primary.value}%` }}
                />
              </div>
            </div>
          )}

          {secondary && (
            <div>
              <div className="flex justify-between text-sm text-[#26295e] mb-1">
                <span>{secondary.label}</span>
                <span>{secondary.value}%</span>
              </div>

              <div className="h-1 bg-[#e6eaf6] rounded-full relative">
                <div
                  className="h-1 bg-[#2f2a68] rounded-full"
                  style={{ width: `${secondary.value}%` }}
                />
              </div>
            </div>
          )}

        </div>

      </div>

      {/* Stress Response */}
      <h6 className="mb-3 text-[#26295e] text-sm">
        Unprofessional Stress Response
      </h6>

      <div className="flex flex-wrap gap-3 justify-between mb-6">
        {stressData.map((item, index) => (
          <StressCircle
            key={index}
            label={item.label}
            value={item.value}
            color={item.color}
          />
        ))}
      </div>
    </div>
  );
};

export default IndividualResultsPreview;